import {SVGProps} from 'react';
import GreyDot from '../../assets/icons/grey-dot.svg';
import Ok from '../../assets/icons/ok.svg';
import Success from '../../assets/icons/success.svg';
import Logo from '../../assets/sportcast/bl_logo_sportcast_hor_1_RGB_pos.svg';

const defaultProps: SVGProps<SVGSVGElement> = {height: 24, width: 24, viewBox: '0 0 24 24'};
const defaultProps100: SVGProps<SVGSVGElement> = {height: 100, width: 100, viewBox: '0 0 100 100'};
const defaultPropsLogo: SVGProps<SVGSVGElement> = {height: 317.5, width: 2154.3, viewBox: '0 0 2154.3 317.5'};

export const IconSuccess = (props: SVGProps<SVGSVGElement>) => {
    return (<Success  {...defaultProps100} {...props}/>);
};

export const IconLogo = (props: SVGProps<SVGSVGElement>) => {
    return (<Logo  {...defaultPropsLogo} {...props}/>);
};

export const IconOk = (props: SVGProps<SVGSVGElement>) => {
    return (<Ok  {...defaultProps} {...props}/>);
};

export const IconGreyDot = (props: SVGProps<SVGSVGElement>) => {
    return (<GreyDot  {...defaultProps} {...props}/>);
};
